import { RouteObject } from 'react-router-dom';

import { DeveloperPortalCommands } from '@tdp';

import { createBotDetailsRoutes } from './pages/BotDetails';

export interface BotRoutesDeps {
  commands: DeveloperPortalCommands;
}
export function createBotsRoutes(): RouteObject[] {
  const botDetailsRoutes = createBotDetailsRoutes();

  return [
    {
      path: ':botId/*',
      async lazy() {
        const { BotDetailsPage } = await import('./pages/BotDetails');
        return { Component: BotDetailsPage };
      },
    },
    {
      path: '',
      async lazy() {
        const { BotListPage } = await import('./pages/BotList');
        return { Component: BotListPage };
      },
    },
    ...botDetailsRoutes,
  ];
}
